import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getPortal } from 'FormsUI/selectors/Portal';
import { isPortalOlderThanDays } from 'FormsUI/utils/PortalUtils';
const usePortalIsTwoOrLessMonthsOld = () => {
  const portal = useSelector(getPortal);
  return useMemo(() => {
    if (!portal) {
      return false;
    }
    return !isPortalOlderThanDays(portal, 60);
  }, [portal]);
};
export default usePortalIsTwoOrLessMonthsOld;